import sislogUserGlobals from "components/UserGlobals";
import moment from "moment";
import validate from "validate.js";

export function initDateRangeValidator() {

    validate.validators.daterange = function(value, options) {
        //      // The value is guaranteed not to be null or undefined but otherwise it
        //      // could be anything.
        function parse(value, options) {
            return +moment.utc(value);
        }
        // Input is a unix timestamp
        function format(value, options) {
            if (value == null) {
                return value;
            }
            if (options.dateOnly || options.dateOnly == null) {
                return new Date(value).toLocaleDateString(sislogUserGlobals.language,
                    { day: "2-digit", month: "2-digit", year: "numeric", timeZone: "UTC" });

            } else {
                return new Date(value).toLocaleDateString(sislogUserGlobals.language,
                    { hour: "2-digit", minute: "2-digit", second: "2-digit", timeZone: "UTC" });
            }
        }
        if (!validate.isFunction(parse) || !validate.isFunction(format)) {
            throw new Error("Both the parse and format functions needs to be set to use the daterange/date validator");
        }

        // Empty values are fine
        if (!validate.isDefined(value)) {
            return;
        }

        options = validate.extend({}, this.options, options);

        let err
            , errors = []
            , earliest = options.earliest ? parse(options.earliest, options) : NaN
            , latest = options.latest ? parse(options.latest, options) : NaN;

        let valFrom = parse(value.from, options);
        let valTo = parse(value.to, options);

        // 86400000 is the number of milliseconds in a day, this is used to remove
        // the time from the date
        if ((isNaN(valFrom) || options.dateOnly && valFrom % 86400000 !== 0) && (isNaN(valTo) || options.dateOnly && valTo % 86400000 !== 0)) {
            err = options.notValid ||
                options.message ||
                this.notValid ||
                "must be a valid date";
            return validate.format(err, { value: arguments[0] });
        }

        if (!isNaN(earliest) && (valFrom < earliest || valTo < earliest)) {
            let err = options.tooEarly ||
                options.message ||
                this.tooEarly ||
                "must be no earlier than %{from}";
            err = validate.format(err, {
                from: format(options.earliest, options),
                to: format(options.latest, options),
            });
            errors.push(err);
        }

        if (!isNaN(latest) && (valFrom > latest || valTo > latest)) {
            err = options.tooLate ||
                options.message ||
                this.tooLate ||
                "must be no later than %{to}";
            err = validate.format(err, {
                from: format(options.earliest, options),
                to: format(options.latest, options),
            });
            errors.push(err);
        }

        if (errors.length) {
            return unique(errors);
        }
    };
}


let unique = function(array) {
    if (!validate.isArray(array)) {
        return array;
    }
    return array.filter(function(el, index, array) {
        return array.indexOf(el) == index;
    });
};
